/**
 * Change Log Button Component
 * 
 * A reusable button to open the Change Log Drawer
 * Used across exhibits (EX2-EX9)
 */

import React, { useState } from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import ChangeLogDrawer from './ChangeLogDrawer';
import { ActionType } from '../../../services/changeLogService';

export interface ChangeLogButtonProps {
  actionType: ActionType;
  annualReportId: string;
  title?: string;
}

const ChangeLogButton: React.FC<ChangeLogButtonProps> = ({
  actionType,
  annualReportId,
  title = 'View change history',
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        icon={<HistoryOutlined />}
        onClick={() => setDrawerOpen(true)}
        title={title}
        style={{ width: 40, height: 40 }}
      />
      <ChangeLogDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        actionType={actionType}
        annualReportId={annualReportId}
      />
    </>
  );
};

export default ChangeLogButton;
